import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { WITHDRAWAL_STATUS } from '../../../constants';
import styles from './index.module.css';

const statusLabels = {
  [WITHDRAWAL_STATUS.PENDING]: 'Pending',
  [WITHDRAWAL_STATUS.REJECTED]: 'Rejected',
  [WITHDRAWAL_STATUS.COMPLETED]: 'Completed',
};

const Status = ({ value }) => {
  const className = classNames(styles.status, styles[value]);

  return <div className={className}>{statusLabels[value]}</div>;
};

Status.propTypes = {
  value: PropTypes.oneOf(Object.values(WITHDRAWAL_STATUS)).isRequired,
};

export default Status;
